import { mapGetters } from 'vuex';
import mvtHotleadForm from '@/common/components/mvthotleadform/mvt-hotleadform.vue';
import mvtMapStatic from '@/common/components/mvtmapstatic/mvt-mapstatic.vue';
import mvtTextbox from '@/common/components/mvttextbox/mvt-textbox.vue';

export default {
    name: 'propertyInlineHotlead',
    components: {
        mvtTextbox,
        mvtMapStatic,
        mvtHotleadForm,
        mvtMapStatic,
    },
    props: {
        assignedAgent: Object,
    },
    data() {
        return {
            hotleadKey: 'propertyInlineHotlead',
            hotleadOpt: null,
        };
    },
    created() {
        this.staticMapData = {
            height: 360,
            markers: [],
        };
        this.hotleadOpt = {
            hotleadType: 'ListingAgentQuestionResponsiveDPP',
            propertyId: this.dpp.propertyId,
            hideProfile: true,
            propertyData: this.dpp,
            showComment: false,
            ojoFormConfigs: {
                showCtaLinks: false,
                showOJOagentInfo: false,
                showDisclaimer: true,
                commnetLabel: 'Comments',
            },
            hideIncentive: true,
        };
    },
    computed: {
        ...mapGetters('glb', ['glb', 'getSplit']),
        ...mapGetters('dpp', ['dpp']),

        isLogin() {
            return !!(this.glb.user && this.glb.user.id);
        },
        opts() {
            return {
                ...this.defaultOptions,
                ...this.options,
            };
        },
    },
    methods: {
        ...mapGetters('glb', ['getComplianceMethod']),
        showNotSupportedByMLS() {
            const compliance = this.getComplianceMethod()();
            return compliance[0] && compliance[0].rule.indexOf('showNotSuportByMLS') >= 0;
        },
    },
};
